/* eslint-disable no-underscore-dangle */
import type { BreederReviewListData } from '@presentation/components';
import { useMemo } from 'react';
import { useGetReviews } from './useGetReviews';

export const useReviewList = (breederId?: number) => {
  const { breederReviewsAggregate, breederReviewsLoading } = useGetReviews(breederId);

  const reviewList = useMemo((): BreederReviewListData => {
    return {
      loading: breederReviewsLoading,
      amount: breederReviewsAggregate?._count?._all ?? undefined,
      average: breederReviewsAggregate?._avg?.globalGrade ?? undefined,
      categoryAverage: {
        cleaning: breederReviewsAggregate?._avg?.hygieneGrade ?? undefined,
        humanContact: breederReviewsAggregate?._avg?.humanContactGrade ?? undefined,
        followup: breederReviewsAggregate?._avg?.followUpGrade ?? undefined,
        wellBeing: breederReviewsAggregate?._avg?.dogsWellBeingGrade ?? undefined,
      },
    } as BreederReviewListData;
  }, [
    breederReviewsAggregate?._avg?.dogsWellBeingGrade,
    breederReviewsAggregate?._avg?.followUpGrade,
    breederReviewsAggregate?._avg?.globalGrade,
    breederReviewsAggregate?._avg?.humanContactGrade,
    breederReviewsAggregate?._avg?.hygieneGrade,
    breederReviewsAggregate?._count?._all,
    breederReviewsLoading,
  ]);

  return { reviewList };
};
